import {toBoolean, toString} from "../helpers/helpers";

export class K2AreaModel {
  areaName: string;
  areaDisabled: boolean;

  static converter = (json?: any) => new K2AreaModel(json);

  constructor(json?: any) {
    json = json || {};

    this.areaName = toString(json.areaName) || "";
    this.areaDisabled = toBoolean(json.areaDisabled);
  }
}
